import { render, staticRenderFns } from "./AdminOtpInput.vue?vue&type=template&id=78908938&scoped=true"
import script from "./AdminOtpInput.vue?vue&type=script&lang=js"
export * from "./AdminOtpInput.vue?vue&type=script&lang=js"
import style0 from "./AdminOtpInput.vue?vue&type=style&index=0&id=78908938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78908938",
  null
  
)

export default component.exports